import React from "react";

export default function PriceFacet({ handleFilterClick, productPrice }) {
  const sortedProductPrice = Object.fromEntries(
    Object.entries(productPrice).sort((a, b) => {
      const getSortValue = (s) => (s.startsWith("$") ? s.length : 1000);
      return getSortValue(a[0]) - getSortValue(b[0]);
    })
  );

  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("price_facet") &&
    plpFacetLabel.price_facet != ""
      ? plpFacetLabel.price_facet
      : "Price";

  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(sortedProductPrice).map((price, i) => {
          if (price && sortedProductPrice[price] > 0) {
            return (
              <div>
                <span
                  id={`price-filter-${i}`}
                  key={i}
                  data-value={`${price.toLowerCase()}`}
                  onClick={(e) =>
                    handleFilterClick("price_facet", e.target.dataset.value)
                  }>
                  {" "}
                  {price} {` (${sortedProductPrice[price]}) `}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
